import React from 'react';
import ProgressbarOne from "../progressbar/ProgressbarOne";
import ScoreProgress from '../progressbar/ScoreProgress';
import SectionTitleTwo from "../sectionTitle/SectionTitleTwo";


const AboutBadge = () => {
    return (
        <div className="about-style-6 rn-section-gap">
            <div className="plr_md--30 plr_sm--30">
                <div className="wrapper theme-shape">
                    <div className="row align-items-center">
                        <div className="col-lg-4 col-md-6 col-12">
                            <div className="thumbnail text-left text-lg-center">
                                <img src="./images/about/about-logo.png" alt="About images" />
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-6 col-12 mt_sm--30">
                            <div className="inner">
                                <span className="theme-gradient subtitle">Member's Badge.</span>
                                <h4 className="color-white maintitle margeneddown">Mohamed Ali Bouzir Tasks Score.</h4>
                                <div className="rbt-progress-style-1 mt--60">
                                    {/*<Link className="btn-default btn-border" to="#">View More Projects</Link>*/}
                                    <ScoreProgress />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutBadge
